import React, { Component } from 'react';
import config from 'react-global-configuration';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import c from 'classnames';
import { Field } from 'formik';
import './style.scss';

const WEBFORM_DEFAULT_FILE_EXTENSIONS = 'gif jpg jpeg png bmp eps tif pict psd txt rtf html odf pdf doc docx ppt pptx xls xlsx xml avi mov mp3 mp4 ogg wav bz2 dmg gz jar rar sit svg tar zip';

class WebformFileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      fileErrors: {}, // eslint-disable-line react/no-unused-state
    };
    this.fileInput = React.createRef();
  }

  getAllowedFileExtensions = () => {
    const { entity } = this.props;
    const allowedFileExtensions = entity.get('#file_extensions');
    return allowedFileExtensions || WEBFORM_DEFAULT_FILE_EXTENSIONS;
  };

  uploadFile = (files, values, key, multiple) => {
    const { language, id } = this.props;
    const API_URL = config.get('API_URL');
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    let uploadedFiles;

    if (multiple) {
      uploadedFiles = [];
    }

    const that = this;

    files.map((file, index) => {
      const formData = new FormData();

      formData.append(`${file.name}`, file);

      const reader = new FileReader();
      reader.onload = function(event) {
        const contents = event.target.result;
        fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
          .then((response) => response.text())
          .then((response) => {
            const csrfToken = response;
            fetch(`${PATH}/webform_rest/${id}/upload/${key}?_format=json`, {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/octet-stream',
                'Content-Disposition': `file; filename="${file.name}"`,
                'X-CSRF-Token': csrfToken,
              },
              body: contents,
            })
              .then((response) => response.json())
              .then((response) => {
                if (response && response.fid) {
                  // Do something with the successful response
                  if (multiple) {
                    uploadedFiles.push(response.fid[0].value);
                  } else {
                    uploadedFiles = response.fid[0].value;
                  }
                  values[key] = uploadedFiles;
                  that.props.validateField(key);
                } else {
                  that.setState({
                    fileErrors: {
                      [file.name]: true,
                    },
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          });
      };
      reader.readAsArrayBuffer(file);
    });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  addFile = (key, values, title, multiple) => {
    const files = Object.entries(this.fileInput.current.files);
    const newFilesArray = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (
        this.getAllowedFileExtensions().indexOf(
          file[1].name.split('.').pop(),
        ) === -1
      ) {
        continue;
      }
      newFilesArray.push(file[1]);
    }

    this.setState((prevState) => {
      return {
        files: [...prevState.files, ...newFilesArray],
      };
    });

    this.uploadFile(newFilesArray, values, key, multiple);
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  removeFile = (key, index, values) => {
    this.setState(
      {
        files: [],
      },
      () => {
        this.props.setFieldValue(
          this.props.entity.get('#webform_key'),
          values[key],
        );
        this.forceUpdate();
      },
    );
  };

  validate = (value) => {
    const { t, entity } = this.props;
    const required = entity.get('#required', false);

    if (required) {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return t(['webform.required']);
      }
    }
  };

  render() {
    const self = this;
    const { t, entity, customClasses, values, ...fieldProps } = this.props;
    const { files } = this.state;

    const wrapperClassNames = c(
      'WebformFileUpload',
      entity.getIn(['#wrapper_attributes', 'class', 0], ''),
    );
    const labelClassNames = c(
      'WebformFileUpload__label',
      entity.getIn(['#label_attributes', 'class', 0], ''),
    );
    const elementClassNames = c(
      'WebformFileUpload__input',
      entity.getIn(['#attributes', 'class', 0], ''),
    );
    const title = entity.get('#title');
    const required = entity.get('#required', false);
    const description = entity.get('#description');
    const key = entity.get('#webform_key');
    const multiple = entity.get('#webform_multiple');

    const checkFileNotUploaded = files.length === 0 || files[0].length === 0;

    return (
      <div className={wrapperClassNames}>
        {title && (
          <label className={labelClassNames} htmlFor={key}>
            {title} {!required && '(optioneel)'}
          </label>
        )}

        <Field
          className={elementClassNames}
          type="file"
          id={key}
          name={key}
          // eslint-disable-next-line no-undefined
          value={undefined}
          multiple={multiple}
          innerRef={self.fileInput}
          onChange={() => {
            self.addFile(key, values, title, multiple);
          }}
          onClick={(event) => {
            /* Allow re-selecting files */ event.target.value = [];
          }}
          accept={this.getAllowedFileExtensions()
            .replaceAll(' ', ',.')
            .replaceAll(/^/g, '.')}
          validate={this.validate}
        />

        <div className={`WebformFileUpload__linkWrapper ${checkFileNotUploaded ? '' : 'fileUploaded'}`}>
          <label htmlFor={key} className="WebformFileUpload__linkWrapper__link">
            <div className="WebformFileUpload__linkWrapper__link__description">
              {t('webform.components.file_upload.upload_file')}
            </div>
          </label>
          <div className="WebformFileUpload__uploaded-files">
            {files
              && files.map((e, i) => {
                return (
                  <div
                    className="WebformFileUpload__uploaded-file"
                    key={e.name}
                  >
                    <div className="WebformFileUpload__uploaded-file__wrapper">
                      <div className="WebformFileUpload__uploaded-file__title">
                        {e.name}
                      </div>
                      <div
                        className="WebformFileUpload__uploaded-file__remove icon icon-cross"
                        onClick={() => {
                          self.removeFile(key, i, values);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className="row">
          {description && (
            <div className="col-8 WebformFileUpload__description">
              {description}
            </div>
          )}
        </div>

        {fieldProps.errors[key] && fieldProps.touched[key] ? (
          <div className="WebformFileUpload__error">
            {fieldProps.errors[key]}
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    language: state.getIn(['ui', 'language']),
  };
}

export default connect(mapStateToProps)(withTranslation()(WebformFileUpload));
